import React from 'react';
import { Card, Row, Col } from 'antd';
import AnyChart from 'anychart-react';
import ExposureTable from './ExposureTable';
import NivoBarChart from '../../../charts/nivo/NivoBarChart';
import NivoScatterChart from "../../../charts/nivo/NivoScatterChart";
import { mapExposureColor, findMaximumExposures } from './utils';
import { chartBaseJsonConfig, scatterConfigJson } from '../../../charts/Anychart/applyAnychartStyles';


const ExposureBarChart = ({ maxExposureData }) => {
  let colors = {};
  const barChartData = maxExposureData.map((item) => {
    colors[item.x] = mapExposureColor(item.value);
    return { id: item.x, [item.x]: parseFloat(item.value) };
  });
  const keys = maxExposureData.map((item) => item.x);

  return (
    <div style={{ height: 300, width: '100%' }}>
      <NivoBarChart
        data={barChartData}
        keys={keys}
        customColors={colors}
        vertical={true}
        barPadding={0.5}
        rotateLabels={0}
        mode={'stacked'}
        legendSize={'small'}
        borderRadius={4}
        showLegend={false}
      />
    </div>
  );
};

const MaxExposure = ({ treeData, symbols }) => {
  const maxExposureData = findMaximumExposures(treeData);
  const currentWeights = symbols;

  const nivoScatterData = maxExposureData.map((d) => {
    const currentWgt = currentWeights[d.x.toLowerCase()] * 100;
    return {
      id: d.x,
      data: [{ x: currentWgt, y: d.value, label: currentWgt > 0 ? d.x : '' }],
    }
  });

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={24} md={10} lg={8}>
        <Card bordered={false}>
          <ExposureTable maxExposureData={maxExposureData} currentWeights={currentWeights} />
        </Card>
      </Col>
      <Col xs={24} sm={24} md={14} lg={16}>
        <Card bordered={false} style={{ marginBottom: '16px' }}>
          <ExposureBarChart maxExposureData={maxExposureData} />
          <div style={{ height: '50vh', width: '100%' }}>
            <NivoScatterChart data={nivoScatterData} keys={nivoScatterData.map(x=>x.id)} showLabels={true} xBounds={[0, 100]} yBounds={[0, 100]} xPadding={0} yPadding={0} />
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default MaxExposure;